import { allTrackSegments, type TrackId } from "./RaceMap";

interface Props {
  trackId: TrackId;
  className?: string;
}

const W = 160;
const H = 90;
const PAD = 10;

const TrackThumb = ({ trackId, className }: Props) => {
  const segments = allTrackSegments[trackId];
  if (!segments || segments.length === 0) return null;

  const all = segments.flatMap((s) => s);
  const lats = all.map((c) => c[0]);
  const lngs = all.map((c) => c[1]);
  const minLat = Math.min(...lats);
  const maxLat = Math.max(...lats);
  const minLng = Math.min(...lngs);
  const maxLng = Math.max(...lngs);
  const dLat = maxLat - minLat || 1;
  const dLng = maxLng - minLng || 1;

  const availW = W - PAD * 2;
  const availH = H - PAD * 2;
  const scale = Math.min(availW / dLng, availH / dLat);
  const offsetX = (W - dLng * scale) / 2;
  const offsetY = (H - dLat * scale) / 2;

  const sx = (lng: number) => offsetX + (lng - minLng) * scale;
  const sy = (lat: number) => offsetY + (maxLat - lat) * scale;

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {segments.map((seg, i) => {
        const d = seg
          .map((c, j) => `${j === 0 ? "M" : "L"}${sx(c[1]).toFixed(1)},${sy(c[0]).toFixed(1)}`)
          .join(" ");
        return (
          <path
            key={i}
            d={d}
            fill="none"
            stroke="#f59e0b"
            strokeWidth={1.8}
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        );
      })}
    </svg>
  );
};

export default TrackThumb;
